export class RedirectRoutesConstants {
  public static UpdateCreditCardUrl: string = "/update-payment";
  public static WellbeingHubUrl: string = "/wellbeing-hub";
  public static BeforeYouStartUrl: string = "/before-you-start";
}
